<script>
import AdminLayout from '@layouts/admin-main'
import { mapState } from 'vuex'
import { fetchConfig, updateConfig } from '@apis/admin/config'
import { fetchGroupList } from '@apis/admin/member'
import every from 'lodash/every'

export default {
  page: {
    title: 'ConfigMember',
    meta: [{ name: 'description', content: 'ConfigMember' }],
  },
  components: { AdminLayout },
  data() {
    return {
      config: null,
      loading: false,
      group_list: [],
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
    c_check_group_value_is_valid() {
      return every(
        this.config.invite_allowed_group_seqs,
        (group) =>
          this.group_list.findIndex((data) => data.seq === group) !== -1
      )
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      Promise.all([this.loadConfig(), this.loadGroupList()]).catch((e) =>
        this.$toasted.error(e.message)
      )
    },
    async loadConfig() {
      const { config } = await fetchConfig('member')
      this.config = config
    },
    async loadGroupList() {
      const { data } = await fetchGroupList()
      this.group_list = data
    },
    handleUpdate() {
      if (this.c_check_group_value_is_valid) {
        this.loading = true
        this.$confirm('config_member.msg_save', 'config_member.check', {
          type: 'warning',
        })
          .then(() => updateConfig('member', this.config))
          .then(() => this.loadConfig())
          .then(() =>
            this.$notify({
              title: this.$t('toasted_msg.title'),
              message: this.$t('admin.msg_save_success'),
              type: 'success',
            })
          )
          .catch((e) =>
            e === 'cancel' ? null : this.$toasted.error(e.message)
          )
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$toasted.error('config_member.msg_no_exist')
      }
    },
  },
}
</script>

<template>
  <AdminLayout>
    <h3 :class="$style.xeAdmin">{{ $t('admin_main.member') }}</h3>
    <form
      v-if="config"
      v-loading="loading"
      action="./"
      method="get"
      @submit.prevent="handleUpdate"
    >
      <table :class="$style.rowTable" cellpadding="0">
        <colgroup>
          <col width="200" />
          <col width="35%" />
          <col width="200" />
          <col width="*" />
        </colgroup>
        <tbody>
          <tr>
            <th scope="col"
              ><div>{{ $t('config_member.login_identifier') }}</div></th
            >
            <td colspan="3">
              <select v-model="config.login_identifier">
                <option
                  v-for="val in [
                    ...constants.member.identifiers,
                    [null, $t('config_member.all_available_identifiers')],
                  ]"
                  :key="val[0]"
                  :value="val[0]"
                  >{{ val[1] }}</option
                >
              </select>
            </td>
          </tr>
          <tr>
            <th scope="col"
              ><div>{{ $t('config_member.enable_allow') }}</div></th
            >
            <td>
              <input
                v-model="config.use_invite_allowed_group"
                type="checkbox"
                true-value="Y"
                false-value="N"
              />
            </td>
            <th scope="col"
              ><div>{{ $t('config_member.acceptance_group') }}</div></th
            >
            <td>
              <label v-for="val in group_list" :key="val.seq">
                <input
                  v-model="config.invite_allowed_group_seqs"
                  name="invite_allowed_group_seqs"
                  type="checkbox"
                  :value="val.seq"
                />{{ val.title }}
              </label>
            </td>
          </tr>
        </tbody>
      </table>
      <div :class="$style.buttonArea">
        <span :class="[$style.button, $style.black, $style.xLarge]"
          ><input type="submit" accesskey="s" :value="$t('admin.save')"
        /></span>
      </div>
    </form>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
